import { RequirablePropertyInputMultipleEmailV2 } from '../../input/PropertyInputGetters';
import { CONTACT_ADDITIONAL_EMAILS } from '../constants/AdditionalPropertyNames';
import { useActionsForProperty } from '../hooks/useActionsForProperty';
import { useAdditionalPropertyValues } from '../hooks/useAdditionalPropertyValues';
import invariant from 'react-utils/invariant';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputMultipleEmailV2Shim = props => {
  const actions = useActionsForProperty();
  invariant(!!actions, 'PropertyInputV2: `actions` is required when `enableMultipleEmailInput={true}`. See https://product.hubteam.com/docs/crm-properties/frontend.html');
  const {
    data: additionalValues,
    loading: additionalValuesLoading
  } = useAdditionalPropertyValues({
    additionalEmails: CONTACT_ADDITIONAL_EMAILS
  });
  if (additionalValuesLoading || additionalValues === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsx(RequirablePropertyInputMultipleEmailV2, Object.assign({}, props, {
    additionalEmails: additionalValues.additionalEmails
  }));
};
export default PropertyInputMultipleEmailV2Shim;